import { render, staticRenderFns } from "./returnOfTheTreasury.vue?vue&type=template&id=6cf27d68&scoped=true"
import script from "./returnOfTheTreasury.vue?vue&type=script&lang=js"
export * from "./returnOfTheTreasury.vue?vue&type=script&lang=js"
import style0 from "./returnOfTheTreasury.vue?vue&type=style&index=0&id=6cf27d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf27d68",
  null
  
)

export default component.exports